import React, { useState } from "react";
import { useParams } from "react-router-dom";
import LobbyPage from "./components/LobbyPage";
import ConferencePage from "./components/ConferencePage";
import "./App.css";
import { SocketProvider } from "./context/SocketProvider";

const App = () => {
  const { roomParam } = useParams();
  const [user, setUser] = useState(null);
  const [room, setRoom] = useState(roomParam || null);

  console.log(roomParam, room);

  return (
    <SocketProvider>
      <div className="app">
        {!user || !room ? (
          <LobbyPage
            onJoin={(userData, roomId) => {
              setUser(userData);
              setRoom(roomId);
            }}
            initialRoomId={roomParam}
          />
        ) : (
          <ConferencePage
            user={user}
            room={room}
            onLeave={() => {
              setUser(null);
              setRoom(null);
            }}
          />
        )}
      </div>
    </SocketProvider>
  );
};

export default App;
